//Hien thi ban do theo format react
import React from "react";
import * as ReactDOM from 'react-dom';
import ol_style_Style from 'ol/style/Style';
import ol_style_Fill from 'ol/style/Fill';
import ol_style_Icon from 'ol/style/Icon';
import ol_style_Text from 'ol/style/Text';
import ol_style_Stroke from 'ol/style/Stroke';
import ol_style_Circle from "ol/style/Circle";
import ol_Feature from 'ol/Feature';
import ol_source_Vector from 'ol/source/Vector';
import ol_geom_Point from 'ol/geom/Point';
import ol_Overlay from 'ol/Overlay';


import {
  interaction,
  layer,
  custom,
  control, //name spaces
  Interactions,
  Overlays,
  Controls, //group
  Layers,
  Overlay,
  Util, //objects
  Map,
} from "../geo/index";
const server = require("../lib/server.js");
const myLib = require("../lib/MyLib.js");

var openSansAdded = false;
// http://stackoverflow.com/questions/14484787/wrap-text-in-javascript
function stringDivider(str, width, spaceReplacer) {
  if (str.length > width) {
    var p = width;
    while (p > 0 && str[p] !== " " && str[p] !== "-") {
      p--;
    }
    if (p > 0) {
      var left;
      if (str.substring(p, p + 1) === "-") {
        left = str.substring(0, p + 1);
      } else {
        left = str.substring(0, p);
      }
      var right = str.substring(p + 1);
      return left + spaceReplacer + stringDivider(right, width, spaceReplacer);
    }
  }
  return str;
}

var getText = function (feature, resolution) {
  var type = "normal";
  var maxResolution = 0.02;
  var text = feature.get("name");
  var placement = undefined;
  if (resolution > maxResolution) {
    text = "";
  } else if (type === "hide") {
    text = "";
  } else if (type === "shorten") {
    text = text.trunc(12);
  } else if (type === "wrap" && (!placement || placement !== "line")) {
    text = stringDivider(text, 16, "\n");
  }
  return text;
};

var createTextStyle = function (feature, resolution) {
  var align = "center";
  var baseline = "bottom";
  var size = "14px";
  var height = 1;
  var offsetX = 0;
  var offsetY = 24;
  var weight = "normal";
  var placement = undefined;
  var maxAngle = undefined;
  var overflow = undefined;
  var rotation = 0;
  var font = weight + " " + size + "/" + height + " Arial";
  var fillColor = "#aa3300";
  var outlineColor = "white";
  var outlineWidth = 3;

  var t = new ol_style_Text({
    textAlign: align == "" ? undefined : align,
    textBaseline: baseline,
    font: font,
    text: getText(feature, resolution),
    fill: new ol_style_Fill({ color: fillColor }),
    stroke: new ol_style_Stroke({ color: outlineColor, width: outlineWidth }),
    offsetX: offsetX,
    offsetY: offsetY,
    placement: placement,
    maxAngle: maxAngle,
    overflow: overflow,
    rotation: rotation,
  });
  return t;
};

var markerStyle = new ol_style_Style({
  image: new ol_style_Icon({
    color: "#4271AE",
    crossOrigin: "anonymous",
    src: "../data/bigdot.png",
    scale: 0.2,
  }),
});

// style

function pointSelectedStyleFunction(feature) {

  return new ol_style_Style({
    image: new ol_style_Icon({
      color: "#4271AE",
      crossOrigin: "anonymous",
      src: "../data/bigdot.png",
      scale: 0.5,
    }),
    text: createTextStyle(feature, 0),
  });
}
var marker = new custom.style.MarkerStyle(
    'https://openlayers.org/en/latest/examples/data/icon.png'
  );
let selectedMarkerStyle = Object.assign({}, markerStyle);

//hien thi cac draw items da luu trong csdl
class KhuVucLayer extends React.Component {
  constructor(props) {
    super(props);
    this.layerStyleFunction = this.layerStyleFunction.bind(this);
    this.state = {
      source: new ol_source_Vector({ wrapX: false, features: props.features }),
    };
    console.log('drawitems:', props.features);
  }
  layerStyleFunction = (feature, resolution) => {
    const type = feature.get('type');
    var v = undefined;
    switch(type) {
      case 'Point':
        v = new ol_style_Style({
          image: new ol_style_Circle({
            radius: 5,
            stroke: new ol_style_Stroke({
              color: "rgba(245, 117, 66,1)",
              width: 2,
            }),
            fill: new ol_style_Fill({
              color: "#ffcc33",
            }),
          }),
        });     
        break;
      case 'LineString':
        v = new ol_style_Style({
          fill: new ol_style_Fill({
              color: 'rgba(150, 150, 150, 0.5)'
          }),
          stroke: new ol_style_Stroke({
              color: 'rgba(0,0,255,0.5)',
              width: 2
          }),
          image: new ol_style_Circle({
              radius: 5,
              fill: new ol_style_Fill({
                  color: '#ffcc33'
              })
          })
      });
        break;
      case 'Polygon':case 'Circle':
        v = new ol_style_Style({
          fill: new ol_style_Fill({
              color: 'rgba(150, 150, 150, 0.5)'
          }),
          stroke: new ol_style_Stroke({
              color: 'rgba(0,0,255,0.5)',
              width: 2
          }),
          image: new ol_style_Circle({
              radius: 5,
              fill: new ol_style_Fill({
                  color: '#ffcc33'
              })
          })
      });
        break;
    }
    return v;
  }
  componentDidMount() {
    
  }
  componentWillReceiveProps(nextProps) {
    if(this.props !== nextProps) {
      this.setState({
        source: new ol_source_Vector({ wrapX: false, features: nextProps.features }),
      });
    }
  }
  componentWillUnmount() {
    this.layerVector.context.map.removeLayer(this.layerVector.layer);
  }
  render() {
    return (
      <layer.Vector
        source={this.state.source}
        style={this.layerStyleFunction}
        ref={(el) => this.layerVector = el}
      >
      </layer.Vector>
    );
  }
}
export default KhuVucLayer;
